import { brlMask } from '../../helpers/masks';

export function Tickets({ tickets, handleAdd, handleRemove, handleBuy, t }) {
  if (tickets.length === 0) {
    return (
      <div className='d-flex justify-content-center py-4'>
        <div
          className='spinner-border text-primary'
          role='status'
        >
          <span className='visually-hidden'>{t('tickets.fields.loading')}</span>
        </div>
      </div>
    );
  }
  const hasSelection = tickets.some((ticket) => ticket.count > 0);
  const total = tickets.reduce((sum, ticket) => sum + ticket.count * ticket.price, 0);
  return (
    <>
      <h2 className='site-title mb-4'>{t('tickets.fields.title')}</h2>
      <div>
        {tickets.map((ticket, index) => (
          <div
            key={ticket.id ?? index}
            className={`ticket-option ${ticket.count > 0 ? 'is-selected' : ''}`}
          >
            <div>
              <div className='ticket-option__name'>{ticket.description}</div>
              <div className='ticket-option__price'>{brlMask(ticket.price)}</div>
            </div>
            <div className='stepper'>
              <button
                type='button'
                className='btn'
                onClick={(e) => handleRemove(e, index)}
                aria-label={`${t('tickets.fields.remove')}: ${ticket.description}`}
              >
                <i
                  className='bi bi-dash'
                  aria-hidden='true'
                />
              </button>
              <span
                className='stepper__value'
                aria-live='polite'
              >
                {ticket.count}
              </span>
              <button
                type='button'
                className='btn'
                onClick={(e) => handleAdd(e, index)}
                aria-label={`${t('tickets.fields.add')}: ${ticket.description}`}
              >
                <i
                  className='bi bi-plus'
                  aria-hidden='true'
                />
              </button>
            </div>
          </div>
        ))}
      </div>
      <div className='ticket-total'>
        <span>Total</span>
        <strong>{brlMask(Math.round(total * 100) / 100)}</strong>
      </div>
      <button
        type='button'
        className='btn btn-primary btn-lg w-100'
        onClick={handleBuy}
        disabled={!hasSelection}
      >
        <i
          className='bi bi-cart-check me-2'
          aria-hidden='true'
        />
        {t('tickets.fields.tobuy')}
      </button>
    </>
  );
}
